import { InformativeMessageDto } from '../interfaces/InformativeMessageDto';

export default function transformInformativeMessageData(informativeMessageDto: InformativeMessageDto): string {
  let body = null;
  informativeMessageDto?.Fields.forEach((f) => {
    if (f.Name === 'Body') {
      body = f.Value;
    }
  });

  return body;
}
